import * as Sentry from "@sentry/capacitor";

import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";
import { AgentStage } from "@/Modules/Agent/Models/Domain";

import { postAsk } from "@/Services/TherapyApi/Agent";
import AnswerTransformer from "@/Modules/Transformers/Agent/Answer";

import useAgentStore from "@/Modules/Agent/Store";
import useAppStore from "@/Modules/App/Store";

import { hasValue } from "@/Utils/Objects";
import { danger } from "@/Utils/Debug";

async function askQuestionAH(customerUuid: string, question: string) {
  const agentStore = useAgentStore();
  const appStore = useAppStore();

  if (!hasValue(customerUuid)) return undefined;

  agentStore.agentStage = AgentStage.WRITING;

  try {
    const answerApi = await postAsk(customerUuid, question);
    const answerDomain = AnswerTransformer.toDomain(answerApi);

    answerDomain.isRecent = true;

    agentStore.conversation.splice(-1, 1, answerDomain);
  } catch (error) {
    danger(error);
    Sentry.captureException(error);
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
    });
  } finally {
    agentStore.agentStage = null;
  }
}

export default askQuestionAH;
